import styled from 'styled-components';
import { Select as AntSelect } from 'antd';

export const TextEditor = styled.div`
    width: 630px;
`;

export const Select = styled(AntSelect)`
    width: 283px;
`;

export const ModalImageWrapper = styled.div`
    border-radius: 5px;
    border: 1px solid rgba(37, 33, 41, 0.15);
    background: #fff;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 104px;
    height: 104px;
`;

export const ModalImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;
